import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";

import * as license from "../../../../constants/license";
import * as globalActions from "../../../../actions/globalActions";
import * as licenseActions from "../../../../actions/licenseActions";
import * as validationHelper from "../../../../helpers/validationHelper";
import * as keyboardActions from "../../../../actions/virtualKeyboardActions";

import imgSkip from "../../../../resources/img/svgicons/skip.svg";
import imgNext from "../../../../resources/img/svgicons/arrow-right-circle.svg";
import imgBack from "../../../../resources/img/svgicons/arrow-left-circle.svg";
import Button, {BUTTON_SMALL} from "../../../global/generic/Button";

class LicenseRegistrationForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            registrationContactPhoneValidation: true,
            registrationContactEmailValidation: true,
            registrationPosName: "",
            registrationPosCountry: "",
            registrationPosRegion: "",
            registrationPosCity: "",
            registrationPosStreet: "",
            registrationPosZip: "",
            registrationContactName: "",
            registrationContactPhone: "",
            registrationContactEmail: "",
            registrationMachineSerialNumber: "",
            registrationMachineProducer: "",
            registrationMachineType: "",
            registrationMachineNumberOfCanisters: ""
        };
    }

    componentDidMount() {
        if (this.props.registrationData !== null) {
            this.setState({
                registrationPosName: this.props.registrationData.pointOfSale.name,
                registrationPosCountry: this.props.registrationData.pointOfSale.country,
                registrationPosRegion: this.props.registrationData.pointOfSale.region,
                registrationPosCity: this.props.registrationData.pointOfSale.city,
                registrationPosStreet: this.props.registrationData.pointOfSale.street,
                registrationPosZip: this.props.registrationData.pointOfSale.zip,
                registrationContactName: this.props.registrationData.contactPerson.name,
                registrationContactPhone: this.props.registrationData.contactPerson.phone,
                registrationContactEmail: this.props.registrationData.contactPerson.email,
                registrationMachineSerialNumber: this.props.registrationData.machineInformation.serialNumber,
                registrationMachineProducer: this.props.registrationData.machineInformation.producer,
                registrationMachineType: this.props.registrationData.machineInformation.type,
                registrationMachineNumberOfCanisters: this.props.registrationData.machineInformation.numberOfCanisters
            });
        }

        window.jQuery("#redlike-licensing-registration-form-contact-name").on(
            "change",
            function (event) {
                if (event.target.value !== this.state.registrationContactName) {
                    this.setState({registrationContactName: event.target.value});
                }
            }.bind(this)
        );
        window.jQuery("#redlike-licensing-registration-form-contact-phone").on(
            "change",
            function (event) {
                if (event.target.value !== this.state.registrationContactPhone) {
                    this.setState({
                        registrationContactPhone: event.target.value,
                        registrationContactPhoneValidation: validationHelper.isPhoneValid(event.target.value)
                    });
                }
            }.bind(this)
        );
        window.jQuery("#redlike-licensing-registration-form-contact-email").on(
            "change",
            function (event) {
                if (event.target.value !== this.state.registrationContactEmail) {
                    this.setState({
                        registrationContactEmail: event.target.value,
                        registrationContactEmailValidation: validationHelper.isEmailValid(event.target.value)
                    });
                }
            }.bind(this)
        );
        window.jQuery("#redlike-licensing-registration-form-pos-name").on(
            "change",
            function (event) {
                if (event.target.value !== this.state.registrationPosName) {
                    this.setState({registrationPosName: event.target.value});
                }
            }.bind(this)
        );
        window.jQuery("#redlike-licensing-registration-form-pos-address").on(
            "change",
            function (event) {
                if (event.target.value !== this.state.registrationPosStreet) {
                    this.setState({registrationPosStreet: event.target.value});
                }
            }.bind(this)
        );
        window.jQuery("#redlike-licensing-registration-form-pos-city").on(
            "change",
            function (event) {
                if (event.target.value !== this.state.registrationPosCity) {
                    this.setState({registrationPosCity: event.target.value});
                }
            }.bind(this)
        );
        window.jQuery("#redlike-licensing-registration-form-pos-zip").on(
            "change",
            function (event) {
                if (event.target.value !== this.state.registrationPosZip) {
                    this.setState({registrationPosZip: event.target.value});
                }
            }.bind(this)
        );
        window.jQuery("#redlike-licensing-registration-form-pos-region").on(
            "change",
            function (event) {
                if (event.target.value !== this.state.registrationPosRegion) {
                    this.setState({registrationPosRegion: event.target.value});
                }
            }.bind(this)
        );
        window.jQuery("#redlike-licensing-registration-form-pos-country").on(
            "change",
            function (event) {
                if (event.target.value !== this.state.registrationPosCountry) {
                    this.setState({registrationPosCountry: event.target.value});
                }
            }.bind(this)
        );
        window.jQuery("#redlike-licensing-registration-form-machine-producer").on(
            "change",
            function (event) {
                if (event.target.value !== this.state.registrationMachineProducer) {
                    this.setState({registrationMachineProducer: event.target.value});
                }
            }.bind(this)
        );
        window.jQuery("#redlike-licensing-registration-form-machine-type").on(
            "change",
            function (event) {
                if (event.target.value !== this.state.registrationMachineType) {
                    this.setState({registrationMachineType: event.target.value});
                }
            }.bind(this)
        );
        window.jQuery("#redlike-licensing-registration-form-machine-serial-number").on(
            "change",
            function (event) {
                if (event.target.value !== this.state.registrationMachineSerialNumber) {
                    this.setState({registrationMachineSerialNumber: event.target.value});
                }
            }.bind(this)
        );
        window.jQuery("#redlike-licensing-registration-form-machine-number-of-canisters").on(
            "change",
            function (event) {
                if (event.target.value !== this.state.registrationMachineNumberOfCanisters) {
                    this.setState({registrationMachineNumberOfCanisters: event.target.value});
                }
            }.bind(this)
        );
    }

    componentWillUnmount() {
        window.jQuery("#redlike-licensing-registration-form-contact-name").unbind("change");
        window.jQuery("#redlike-licensing-registration-form-contact-phone").unbind("change");
        window.jQuery("#redlike-licensing-registration-form-contact-email").unbind("change");
        window.jQuery("#redlike-licensing-registration-form-pos-name").unbind("change");
        window.jQuery("#redlike-licensing-registration-form-pos-address").unbind("change");
        window.jQuery("#redlike-licensing-registration-form-pos-city").unbind("change");
        window.jQuery("#redlike-licensing-registration-form-pos-zip").unbind("change");
        window.jQuery("#redlike-licensing-registration-form-pos-region").unbind("change");
        window.jQuery("#redlike-licensing-registration-form-pos-country").unbind("change");
        window.jQuery("#redlike-licensing-registration-form-machine-producer").unbind("change");
        window.jQuery("#redlike-licensing-registration-form-machine-type").unbind("change");
        window.jQuery("#redlike-licensing-registration-form-machine-serial-number").unbind("change");
        window.jQuery("#redlike-licensing-registration-form-machine-number-of-canisters").unbind("change");
    }

    componentDidUpdate(prevProps) {
        if (this.props.registrationData !== prevProps.registrationData && this.props.registrationData !== null) {
            this.setState({
                registrationPosName: this.props.registrationData.pointOfSale.name,
                registrationPosCountry: this.props.registrationData.pointOfSale.country,
                registrationPosRegion: this.props.registrationData.pointOfSale.region,
                registrationPosCity: this.props.registrationData.pointOfSale.city,
                registrationPosStreet: this.props.registrationData.pointOfSale.street,
                registrationPosZip: this.props.registrationData.pointOfSale.zip,
                registrationContactName: this.props.registrationData.contactPerson.name,
                registrationContactPhone: this.props.registrationData.contactPerson.phone,
                registrationContactEmail: this.props.registrationData.contactPerson.email,
                registrationMachineSerialNumber: this.props.registrationData.machineInformation.serialNumber,
                registrationMachineProducer: this.props.registrationData.machineInformation.producer,
                registrationMachineType: this.props.registrationData.machineInformation.type,
                registrationMachineNumberOfCanisters: this.props.registrationData.machineInformation.numberOfCanisters
            });
        }
    }

    getRegistrationData = () => {
        return {
            PointOfSale: {
                Name: this.state.registrationPosName,
                Country: this.state.registrationPosCountry,
                Region: this.state.registrationPosRegion,
                City: this.state.registrationPosCity,
                Street: this.state.registrationPosStreet,
                Zip: this.state.registrationPosZip
            },
            ContactPerson: {
                Name: this.state.registrationContactName,
                Phone: this.state.registrationContactPhone,
                Email: this.state.registrationContactEmail
            },
            Machine: {
                SerialNumber: this.state.registrationMachineSerialNumber,
                Type: this.state.registrationMachineType,
                Producer: this.state.registrationMachineProducer,
                NumberOfCanisters: this.state.registrationMachineNumberOfCanisters
            }
        };
    };

    handleContactNameInputFocus = () => {
        if (this.props.virtualKeyboardEnabled && this.props.keyboardState) {
            this.props.dispatchSetUniversalKeyboardStateAction(
                true,
                "redlike-licensing-registration-form-contact-name"
            );
        }
    };

    handleContactPhoneInputFocus = () => {
        if (this.props.virtualKeyboardEnabled && this.props.keyboardState) {
            this.props.dispatchSetUniversalKeyboardStateAction(
                true,
                "redlike-licensing-registration-form-contact-phone"
            );
        }
    };

    handleContactEmailInputFocus = () => {
        if (this.props.virtualKeyboardEnabled && this.props.keyboardState) {
            this.props.dispatchSetUniversalKeyboardStateAction(
                true,
                "redlike-licensing-registration-form-contact-email"
            );
        }
    };

    handlePosNameInputFocus = () => {
        if (this.props.virtualKeyboardEnabled && this.props.keyboardState) {
            this.props.dispatchSetUniversalKeyboardStateAction(true, "redlike-licensing-registration-form-pos-name");
        }
    };

    handlePosAddressInputFocus = () => {
        if (this.props.virtualKeyboardEnabled && this.props.keyboardState) {
            this.props.dispatchSetUniversalKeyboardStateAction(true, "redlike-licensing-registration-form-pos-address");
        }
    };

    handlePosCityInputFocus = () => {
        if (this.props.virtualKeyboardEnabled && this.props.keyboardState) {
            this.props.dispatchSetUniversalKeyboardStateAction(true, "redlike-licensing-registration-form-pos-city");
        }
    };

    handlePosZipInputFocus = () => {
        if (this.props.virtualKeyboardEnabled && this.props.keyboardState) {
            this.props.dispatchSetUniversalKeyboardStateAction(true, "redlike-licensing-registration-form-pos-zip");
        }
    };

    handlePosRegionInputFocus = () => {
        if (this.props.virtualKeyboardEnabled && this.props.keyboardState) {
            this.props.dispatchSetUniversalKeyboardStateAction(true, "redlike-licensing-registration-form-pos-region");
        }
    };

    handlePosCountryInputFocus = () => {
        if (this.props.virtualKeyboardEnabled && this.props.keyboardState) {
            this.props.dispatchSetUniversalKeyboardStateAction(true, "redlike-licensing-registration-form-pos-country");
        }
    };

    handleMachineProducerInputFocus = () => {
        if (this.props.virtualKeyboardEnabled && this.props.keyboardState) {
            this.props.dispatchSetUniversalKeyboardStateAction(
                true,
                "redlike-licensing-registration-form-machine-producer"
            );
        }
    };

    handleMachineTypeInputFocus = () => {
        if (this.props.virtualKeyboardEnabled && this.props.keyboardState) {
            this.props.dispatchSetUniversalKeyboardStateAction(
                true,
                "redlike-licensing-registration-form-machine-type"
            );
        }
    };

    handleMachineSerialNumberInputFocus = () => {
        if (this.props.virtualKeyboardEnabled && this.props.keyboardState) {
            this.props.dispatchSetUniversalKeyboardStateAction(
                true,
                "redlike-licensing-registration-form-machine-serial-number"
            );
        }
    };

    handleMachineNumberOfCanistersInputFocus = () => {
        if (this.props.virtualKeyboardEnabled && this.props.keyboardState) {
            this.props.dispatchSetUniversalKeyboardStateAction(
                true,
                "redlike-licensing-registration-form-machine-number-of-canisters"
            );
        }
    };

    handleRegistrationPosNameChange = (event) => {
        this.setState({
            registrationPosName: event.target.value
        });
    };

    handleRegistrationPosCountryChange = (event) => {
        this.setState({
            registrationPosCountry: event.target.value
        });
    };

    handleRegistrationPosRegionChange = (event) => {
        this.setState({
            registrationPosRegion: event.target.value
        });
    };

    handleRegistrationPosCityChange = (event) => {
        this.setState({
            registrationPosCity: event.target.value
        });
    };

    handleRegistrationPosStreetChange = (event) => {
        this.setState({
            registrationPosStreet: event.target.value
        });
    };

    handleRegistrationPosZipChange = (event) => {
        this.setState({
            registrationPosZip: event.target.value
        });
    };

    handleRegistrationContactNameChange = (event) => {
        this.setState({
            registrationContactName: event.target.value
        });
    };

    handleRegistrationContactPhoneChange = (event) => {
        this.setState({
            registrationContactPhone: event.target.value,
            registrationContactPhoneValidation: validationHelper.isPhoneValid(event.target.value)
        });
    };

    handleRegistrationContactEmailChange = (event) => {
        this.setState({
            registrationContactEmail: event.target.value,
            registrationContactEmailValidation: validationHelper.isEmailValid(event.target.value)
        });
    };

    handleRegistrationMachineSerialNumberChange = (event) => {
        this.setState({
            registrationMachineSerialNumber: event.target.value
        });
    };

    handleRegistrationMachineProducerChange = (event) => {
        this.setState({
            registrationMachineProducer: event.target.value
        });
    };

    handleRegistrationMachineTypeChange = (event) => {
        this.setState({
            registrationMachineType: event.target.value
        });
    };

    handleRegistrationMachineNumberOfCanistersBlur = (event) => {
        if (validationHelper.isIntegerValueValid(event.target.value)) {
            let numberOfCanisters = String(Number(event.target.value));

            this.setState({
                registrationMachineNumberOfCanisters: numberOfCanisters === "0" ? "" : numberOfCanisters
            });
        } else {
            this.setState({
                registrationMachineNumberOfCanisters: ""
            });
        }
    };

    handleRegistrationMachineNumberOfCanistersChange = (event) => {
        if (validationHelper.isIntegerValueValid(event.target.value)) {
            this.setState({
                registrationMachineNumberOfCanisters: event.target.value
            });
        }
    };

    handleGoBackButtonClick = () => {
        this.props.dispatchGoBackAction(this.props.processStep - 1);
    };

    handleConfirmRegistrationFormClick = () => {
        this.props.dispatchSetDataAction(this.getRegistrationData());
    };

    handleContinueToRedlikeClick = () => {
        this.props.dispatchStartSoftwareInitializationAction();
    };

    getTooltipTranslation = () => {
        if (!this.state.registrationContactPhoneValidation) {
            return translate("license.invalidPhone");
        }

        if (!this.state.registrationContactEmailValidation) {
            return translate("license.invalidEmail");
        }

        if (this.state.registrationPosName.trim().length === 0) {
            return translate("license.emptyName");
        }

        if (this.state.registrationPosCity.trim().length === 0) {
            return translate("license.emptyCity");
        }

        if (this.state.registrationPosCountry.trim().length === 0) {
            return translate("license.emptyCountry");
        }

        return null;
    };

    getContinueButton = () => {
        return (
            <Button
                size={BUTTON_SMALL}
                label={<Translate value="general.continue" />}
                onClick={this.handleConfirmRegistrationFormClick}
                svgBefore={imgNext}
                tooltipText={this.getTooltipTranslation()}
                disabled={
                    this.state.registrationPosName.trim().length === 0 ||
                    this.state.registrationPosCountry.trim().length === 0 ||
                    this.state.registrationPosCity.trim().length === 0 ||
                    !this.state.registrationContactPhoneValidation ||
                    !this.state.registrationContactEmailValidation
                }
            />
        );
    };

    getSkipNewLicenseButton = () => {
        if (this.props.setupSoftware || this.props.licenseStatus !== license.STATUS_VALID_LEASED_LICENSE) {
            return "";
        }

        return (
            <Button
                size={BUTTON_SMALL}
                label={<Translate value="general.skip" />}
                onClick={this.handleContinueToRedlikeClick}
                svgBefore={imgSkip}
            />
        );
    };

    getContactSection = () => {
        return (
            <React.Fragment>
                <div className="col-xs-12 license-text">
                    <Translate value="license.fillRegistration" />
                </div>
                <div className="col-xs-12 license-registration-text">
                    <Translate value="license.contactPerson" />
                </div>
                <div className="col-xs-5 text-right color-primary">
                    <Translate value="general.name" />:
                </div>
                <div className="col-xs-7">
                    <input
                        id="redlike-licensing-registration-form-contact-name"
                        type="text"
                        value={this.state.registrationContactName}
                        onChange={this.handleRegistrationContactNameChange}
                        onFocus={this.handleContactNameInputFocus}
                    />
                </div>
                <div className="col-xs-5 text-right color-primary">
                    <Translate value="general.phone" />:
                </div>
                <div className="col-xs-7">
                    <input
                        id="redlike-licensing-registration-form-contact-phone"
                        type="text"
                        value={this.state.registrationContactPhone}
                        onChange={this.handleRegistrationContactPhoneChange}
                        onFocus={this.handleContactPhoneInputFocus}
                    />
                </div>
                <div className="col-xs-5 text-right color-primary">
                    <Translate value="general.email" />:
                </div>
                <div className="col-xs-7">
                    <input
                        id="redlike-licensing-registration-form-contact-email"
                        type="text"
                        value={this.state.registrationContactEmail}
                        onChange={this.handleRegistrationContactEmailChange}
                        onFocus={this.handleContactEmailInputFocus}
                    />
                </div>
            </React.Fragment>
        );
    };

    getPosSection = () => {
        return (
            <React.Fragment>
                <div className="col-xs-12 license-registration-text">
                    <Translate value="license.pointOfSale" />
                </div>
                <div className="col-xs-5 text-right color-primary">
                    <Translate value="posInfo.shopName" />:
                </div>
                <div className="col-xs-7 required">
                    <input
                        id="redlike-licensing-registration-form-pos-name"
                        type="text"
                        value={this.state.registrationPosName}
                        onChange={this.handleRegistrationPosNameChange}
                        onFocus={this.handlePosNameInputFocus}
                    />
                </div>
                <div className="col-xs-5 text-right color-primary">
                    <Translate value="posInfo.address" />:
                </div>
                <div className="col-xs-7">
                    <input
                        id="redlike-licensing-registration-form-pos-address"
                        type="text"
                        value={this.state.registrationPosStreet}
                        onChange={this.handleRegistrationPosStreetChange}
                        onFocus={this.handlePosAddressInputFocus}
                    />
                </div>
                <div className="col-xs-5 text-right color-primary">
                    <Translate value="general.city" />:
                </div>
                <div className="col-xs-7 required">
                    <input
                        id="redlike-licensing-registration-form-pos-city"
                        type="text"
                        value={this.state.registrationPosCity}
                        onChange={this.handleRegistrationPosCityChange}
                        onFocus={this.handlePosCityInputFocus}
                    />
                </div>
                <div className="col-xs-5 text-right color-primary">
                    <Translate value="license.zip" />:
                </div>
                <div className="col-xs-7">
                    <input
                        id="redlike-licensing-registration-form-pos-zip"
                        type="text"
                        value={this.state.registrationPosZip}
                        onChange={this.handleRegistrationPosZipChange}
                        onFocus={this.handlePosZipInputFocus}
                    />
                </div>
                <div className="col-xs-5 text-right color-primary">
                    <Translate value="license.region" />:
                </div>
                <div className="col-xs-7">
                    <input
                        id="redlike-licensing-registration-form-pos-region"
                        type="text"
                        value={this.state.registrationPosRegion}
                        onChange={this.handleRegistrationPosRegionChange}
                        onFocus={this.handlePosRegionInputFocus}
                    />
                </div>
                <div className="col-xs-5 text-right color-primary">
                    <Translate value="license.country" />:
                </div>
                <div className="col-xs-7 required">
                    <input
                        id="redlike-licensing-registration-form-pos-country"
                        type="text"
                        value={this.state.registrationPosCountry}
                        onChange={this.handleRegistrationPosCountryChange}
                        onFocus={this.handlePosCountryInputFocus}
                    />
                </div>
            </React.Fragment>
        );
    };

    getMachineSection = () => {
        if (this.props.product !== null && this.props.product.id !== license.PRODUCT_PRICING) {
            return (
                <React.Fragment>
                    <div className="col-xs-12 license-registration-text">
                        <Translate value="posInfo.machineInformation" />
                    </div>
                    <div className="col-xs-5 text-right color-primary">
                        <Translate value="license.producer" />:
                    </div>
                    <div className="col-xs-7">
                        <input
                            id="redlike-licensing-registration-form-machine-producer"
                            type="text"
                            value={this.state.registrationMachineProducer}
                            onChange={this.handleRegistrationMachineProducerChange}
                            onFocus={this.handleMachineProducerInputFocus}
                        />
                    </div>
                    <div className="col-xs-5 text-right color-primary">
                        <Translate value="general.type" />:
                    </div>
                    <div className="col-xs-7">
                        <input
                            id="redlike-licensing-registration-form-machine-type"
                            type="text"
                            value={this.state.registrationMachineType}
                            onChange={this.handleRegistrationMachineTypeChange}
                            onFocus={this.handleMachineTypeInputFocus}
                        />
                    </div>
                    <div className="col-xs-5 text-right color-primary">
                        <Translate value="license.serialNumber" />:
                    </div>
                    <div className="col-xs-7">
                        <input
                            id="redlike-licensing-registration-form-machine-serial-number"
                            type="text"
                            value={this.state.registrationMachineSerialNumber}
                            onChange={this.handleRegistrationMachineSerialNumberChange}
                            onFocus={this.handleMachineSerialNumberInputFocus}
                        />
                    </div>
                    <div className="col-xs-5 text-right color-primary">
                        <Translate value="general.numberOfCanisters" />:
                    </div>
                    <div className="col-xs-7">
                        <input
                            id="redlike-licensing-registration-form-machine-number-of-canisters"
                            type="text"
                            value={this.state.registrationMachineNumberOfCanisters}
                            onChange={this.handleRegistrationMachineNumberOfCanistersChange}
                            onBlur={this.handleRegistrationMachineNumberOfCanistersBlur}
                            onFocus={this.handleMachineNumberOfCanistersInputFocus}
                        />
                    </div>
                </React.Fragment>
            );
        }
        return "";
    };

    render() {
        return (
            <div className="flex-child fill-flex-space flex flex-column">
                <div className="form-box-dark-blue row registration-form slim-scroll flex-child fill-flex-space">
                    {this.getContactSection()}
                    {this.getPosSection()}
                    {this.getMachineSection()}
                </div>
                <div className="col-12 flex flex-align-center flex-gap-3vh margin-bottom-10">
                    <Button
                        size={BUTTON_SMALL}
                        label={<Translate value="general.back" />}
                        onClick={this.handleGoBackButtonClick}
                        svgBefore={imgBack}
                    />
                    {this.getContinueButton()}
                    {this.getSkipNewLicenseButton()}
                </div>
            </div>
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        setupSoftware: store.module.setupSoftware,
        product: store.license.product,
        licenseStatus: store.license.licenseStatus,
        processStep: store.license.processStep,
        registrationData: store.license.registrationData,
        virtualKeyboardEnabled: store.settings.virtualKeyboardEnabled,
        keyboardState: store.virtualKeyboard.keyboardState
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchStartSoftwareInitializationAction: () => {
            dispatch(globalActions.startSoftwareInitialization());
        },
        dispatchGoBackAction: (toStep) => {
            dispatch(licenseActions.setStep(toStep));
        },
        dispatchSetDataAction: (data) => {
            dispatch(licenseActions.setData(data));
        },
        dispatchSetUniversalKeyboardStateAction: (state, selector) => {
            dispatch(keyboardActions.setUniversalKeyboardState(state, selector));
        }
    };
};

export default LicenseRegistrationForm = connect(mapStoreToProps, mapDispatchToProps)(LicenseRegistrationForm);
